<template>
  <div id="app">
    <header class="header">
      <div class="logo">
        <div class="triangle"></div>
      </div>
      <Search @item_selected="itemSelected" />
    </header>
    <Item v-if="item" :item="item" />
  </div>
</template>

<script>
import Search from './components/Search.vue';
import Item from './components/Item.vue';

export default {
  name: 'App',
  components: {
    Search,
    Item,
  },

  data() {
    return {
      item: null,
    };
  },

  beforeMount() {
    // this.getPopularMovies();
  },

  methods: {
    itemSelected: function(item) {
      this.item = item;
    },
  },
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700,800&display=swap');

:root {
  --light-color: white;
  --dark-color: #363948;
  --link-color: #5de1e5;
  --header-bg: rgba(26, 31, 52, 0.5);
  --bg: rgb(51, 8, 103);
  --border-color: #e0e0e0;
  --logo-size: 20px;
}

* {
  box-sizing: border-box;
}

// reset
ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
h1,
h2,
h3 {
  margin: 0;
  padding: 0;
}

iframe {
  max-width: 640px;
  height: auto;
}

body {
  font-family: 'Open Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: var(--light-color);
  margin: 0;
  padding: 0;
  font-size: 16px;
  line-height: 1.4;
  background-color: var(--bg);

  a {
    color: var(--link-color);
    text-decoration: none;
    transition-duration: 0.3s;
  }

  a:hover {
    transition-duration: 0.05s;
  }

  .header {
    display: flex;
    align-content: center;
    position: fixed;
    width: 100%;
    z-index: 3;

    .logo {
      width: 100px;
      height: 60px;
      align-self: center;
      padding: 15px 30px;
      position: absolute;
      z-index: 99;

      .triangle {
        cursor: pointer;
        position: relative;
        background-image: linear-gradient(to top, #37ecba 0%, #72afd3 100%);
        text-align: left;
        width: var(--logo-size);
        height: var(--logo-size);
        border-top-right-radius: 30%;
        transform-origin: center center;
        transition: all 500ms ease-in-out;
        transform: rotate(-90deg) skewX(-30deg) scale(1, 0.866);

        &:before,
        &:after {
          content: '';
          position: absolute;
          background-image: inherit;
          width: var(--logo-size);
          height: var(--logo-size);
          border-top-right-radius: 30%;
        }

        &:before {
          transform: rotate(-135deg) skewX(-45deg) scale(1.414, 0.707) translate(0, -50%);
        }
        &:after {
          transform: rotate(135deg) skewY(-45deg) scale(0.707, 1.414) translate(50%);
        }

        &:hover {
          background-image: linear-gradient(to top, #cc208e 0%, #6713d2 100%);
        }
      }
    }
  }
}
</style>
